import React, { useState } from "react";
import { Container, Card, TextField, Button, CssBaseline, Box, Alert } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay-ts";
import BeatLoader from "react-spinners/BeatLoader";
import { createBrowserHistory } from "history";
import { passwordResetSchema, forgotPasswordInitialValues } from "../helpers/validationSchemas";
import { resetPassword } from "../services/registerService";
import TitleBox from "../components/TitleBox";
import TurnstileWrapped from "../components/TurnstyleWrapped";

function ResetPage() {
  const history = createBrowserHistory();
  const [recaptchaCompleted, setRecaptchaCompleted] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (values: any, resetForm: Function) => {
    setLoading(true);
    await resetPassword({ email: values.email })
      .then(() => {
        setLoading(false);
        resetForm();
        Swal.fire({
          icon: "success",
          title: "Password Reset Request Submitted",
          /* eslint-disable-next-line */
          text: "You will receive an email with instructions to reset your password shortly. Please check your inbox (and spam folder, if necessary).",
          showConfirmButton: false,
          timer: 3000 // Auto-close after 5 seconds
        }).then(() => {
          history.back();
        });
      })
      .catch(() => {
        setLoading(false);
        resetForm();
        Swal.fire({
          icon: "success",
          title: "Password Reset Request Submitted",
          /* eslint-disable-next-line */
          text: "You will receive an email with instructions to reset your password shortly. Please check your inbox (and spam folder, if necessary).",
          showConfirmButton: false,
          timer: 3000 // Auto-close after 5 seconds
        }).then(() => {
          history.back();
        });
      });
  };

  return (
    <Container component="main" maxWidth="sm">
      <LoadingOverlay active={isLoading} spinner={<BeatLoader color="#F4B43C" />}>
        <CssBaseline />
        <TitleBox title="Forgot Password" />

        <Card
          sx={{
            padding: 5,
            textAlign: "center",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
          }}
        >
          <Formik
            initialValues={forgotPasswordInitialValues}
            validationSchema={passwordResetSchema}
            onSubmit={() => {}}
          >
            {({ isSubmitting, resetForm, values, isValid }) => (
              <Form>
                <Field
                  as={TextField}
                  variant="outlined"
                  margin="normal"
                  size="small"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoFocus
                  className="input-field"
                />
                <ErrorMessage name="email" component="div" className="error-message" />

                <TurnstileWrapped 
                  action="forgotten-password"
                  onChanged={(isValid)=>{
                    if(isValid){
                      setRecaptchaCompleted(true);
                    } else {
                      setRecaptchaCompleted(false);
                    }
                  }}
                />

                <Button
                  id="submit-button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(values, resetForm);
                  }}
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: "#F5B43B",
                    color: "black",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                  disabled={isSubmitting || !recaptchaCompleted || !isValid}
                >
                  Submit
                </Button>
              </Form>
            )}
          </Formik>
        </Card>
      </LoadingOverlay>
    </Container>
  );
}

export default ResetPage;
